module.exports = __webpack_public_path__ + "img/news_head_1.025f35bd.jpg";